import {useQuery} from "react-query";
import {PostModel, PostPaginatedModel} from "./postTypes";
import {getJsonServer} from "../../axios/generic-api2-calls";

export function useFetchPosts(currentPage: number, term:string,key:string = 'posts') {
    return useQuery<PostPaginatedModel>(key,() => getJsonServer(`/post?_page=${currentPage}&_limit=5&title_like=${term}`, true));
}

export function useFetchPostSlug(slug:string, key:string = 'post') {
    return useQuery<PostModel>(key, async () => (await getJsonServer(`/post?slug=${slug}`))[0]);
}
